import { IBaseEntity } from 'types/detailsEntityType';

export const generateEntities = <T extends IBaseEntity>(
  baseEntity: T,
  currentEntities: T[],
  entityGenerationLimit: number = 30
): T[] => {
  const newEntities: T[] = [];

  const baseId = parseInt(baseEntity.spaceId, 10);

  for (let i = 1; i < entityGenerationLimit - currentEntities.length + 1; i++) {
    const newFrame: T = {
      ...baseEntity,
      spaceId: (baseId + i).toString(),
    };
    newEntities.push(newFrame);
  }

  return [...currentEntities, ...newEntities];
};
